import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import { userRoleInfo } from "@/api/data";
import infoList from "@/mixins/infoList";
export default {
  name: "compUserInfo",
  props: {
    btnType: Number,
    serverList: Object
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: userRoleInfo,
      searchInfo: {},
      code: 1
    };
  },
  methods: {
    loadTatleData: function loadTatleData(m) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // this.$router.push({ query: {} });

              _this.searchInfo = m;
              if (!(_this.searchInfo.roleId || _this.searchInfo.roleName)) {
                _context.next = 9;
                break;
              }
              _this.loading = true;
              _context.next = 5;
              return _this.getTableData(1);
            case 5:
              _this.loading = false;
              if (!_this.tableData || _this.tableData && _this.tableData.length === 0) {
                _this.$message({
                  message: "玩家信息，暂无数据"
                });
              }
              _context.next = 10;
              break;
            case 9:
              _this.tableData = [];
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};